import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SportCode from 'components/common/SportCode';
import { getURL } from 'helpers/utils';
import Label from "components/general/Label"
import { useUrlFriendlyToParameters, useGetURL } from "helpers/urlFriendly";



const Captain = () => {
	const translateDesc = Label({ data: "LabelCaptainDesc" })
	const translate = Label({ data: "LabelCaptain" })

	return (
		<>
			<span className='ms-1 d-none d-sm-block text-nowrap'>({translateDesc})</span>
			<abbr className='ms-1 d-block d-sm-none' title={translateDesc}>{translate}</abbr>
		</>
	)
}

const CaptainAbbr = () => {
	const translateDesc = Label({ data: "LabelCaptainShort" })
	const translate = Label({ data: "LabelCaptain" })

	return (
		<>
			<span className='ms-1 d-none d-sm-block text-nowrap'>({translateDesc})</span>
			<abbr className='ms-1 d-block d-sm-none' title={translateDesc}>{translate}</abbr>
		</>
	)
}

const CompetitorLink = (props) => {
	const competitorCode = props?.code;
	let params = useUrlFriendlyToParameters();
	params["mirs_code"] = competitorCode;
	let page = "bios";
	let isAthlete = false;
	let typer = props?.__typename;
	let cat = props?.mainFunction?.category;

	if(typer!==null){
		if(typer==="Team"){
			isAthlete = false
		}
		else if(cat!==null){
			if(cat==="A")
				isAthlete = true
			else
				isAthlete = false
		}
	}
	
	const url = useGetURL(params, page)
	let component;



	if (props.noLink || !isAthlete )  {
		component = CompetitorBox(props);
	} else {
		component = <Link to={url} className='competitor-container'>
			{CompetitorBox(props)}
		</Link>
	}
	return (
		<>
			{component}
			{props?.showGuide && props?.guide && <div className='small'><Label data='LabelGuide' />:&nbsp;{props?.guide?.shortName}</div>}
		</>
	)
}

const CompetitorNolink2222 = (props) => {
	return (
		<>
			{CompetitorBox(props)}
			{props?.showGuide && <div className='small'><Label data='LabelGuides' />:&nbsp;{props?.guide?.shortName}</div>}
		</>
	)
}

const CompetitorBox = (props) => {
	let params = useUrlFriendlyToParameters();
	const captain = props?.eventUnitEntries?.find(eue => eue.eue_code === 'CAPTAIN') ? <Captain /> : ''
	const captainAbbr = props?.eventUnitEntries?.find(eue => eue.eue_code === 'CAPTAIN') ? <CaptainAbbr /> : ''
	const small = props?.small;
	const strike = props?.strike && " text-decoration-line-through";
	const seed  = props?.seed ? <span className='ps-1'><sup>{props?.seed}</sup></span> : <></>
	const breakCouples = props?.breakCouples;
	//const disciplineClass = props?.disciplineClass?.classCode ? props?.disciplineClass?.classCode : ''  //deprecated for using abbr
	let starter = props?.eventUnitEntries?.find(eue => eue.eue_code === 'STARTER' && eue.eue_value === 'Y') ? '*' : ''
	let substitute = props?.eventUnitEntries?.find(eue => eue.eue_code === 'SUBSTITUTE' && eue.eue_value === 'S') ? '(S)' : ''
	let suspendedCode = props?.eventUnitEntries?.find(eue => eue.eue_code === 'STATUS')?.eue_value;
	suspendedCode = (<SportCode discipline='BKB' entity='@AthleteStatus' code={suspendedCode} />)

	let d_block_d_md_none = props.alwaysNoc ? "" : "d-block d-md-none";
	let competitor_country_flag_container = props.alwaysNoc ? 'competitor-country-flag-container-always-noc' : 'competitor-country-flag-container';
	let d_flex_flex_row = props.alwaysNoc ? 'd-flex flex-row' : ''

	const [showImage, setShowImage] = useState(true);
	const [showNocImage, setShowNocImage] = useState(true);

	const hideImg = (event) => {
		// this.setState({ showImg: false });
		setShowImage(false);
	};
	const hideNocImg = (event) => {
		setShowNocImage(false);
	};

	const competitorCode = props?.code;

	const name = props?.name;
	let shortName = props?.shortName;
	shortName = breakCouples && shortName?.includes('/') ?  shortName?.replace('/', '/ ') : shortName;

	const noc = props?.organisation?.code;
	const nocDesc = props?.organisation?.longDescription;
	const alignEnd = props?.alignEnd ? 'align-end' : '';
	const hideNoc = props?.hideNoc === undefined ? false : props?.hideNoc;
	let medicalClass = props?.medicalClass?.classCode && '(' + props?.medicalClass?.classCode + ')'
	let showMedicalClass = (props?.showMedicalClass === undefined || props?.showMedicalClass === true) ? true : false;
	medicalClass = showMedicalClass && medicalClass

	let extradata = props.showCaptain ? captain : props.showCaptainAbbr ? captainAbbr : undefined
	extradata = props.showSuspendedCode ? <>{extradata} {suspendedCode}</> : extradata
	extradata = props.showSubstitute ? <>{extradata} {substitute}</> : extradata
	extradata = props.showSeed && props?.seed !== undefined ? <>{extradata} {'(' + props.seed + ')'}</> : extradata
	extradata = medicalClass
		? <>
			{extradata} (<abbr title={props?.medicalClass?.description}>{props?.medicalClass?.classCode}</abbr>)
		</>
		: <>{extradata}</>

	params["mirs_code"] = competitorCode;

	return (

		<>
			{props.showStarter ? <div className='w-5'>{starter}</div> : ''}
			{
				!props.hidePicture &&
				<div className='competitor-image-container d-none d-sm-block' >
					<div className='competitor-image' >
						{showImage ? (
							<picture>
								<img
									aria-hidden="true"
									className='object-fit-cover-picture-img'
									src={`/assets/images/photos/photo.webp`}
									alt={name}
									onError={hideImg}
								/>
							</picture>
						) : (
							''
						)}

					</div>
				</div>
			}

			<div className={`competitor-name ${alignEnd}  ${d_flex_flex_row}`}>
				{
					!hideNoc && (
						<span className={`competitor-country  ${d_block_d_md_none}`}>
							<div className='competitor-country-container'>
								<div className={competitor_country_flag_container}>

									{showNocImage ? (
										<img
											className='competitor-country-flag'
											aria-hidden="true"
											src={`/assets/images/flags/${noc}.png`}
											alt={nocDesc}
											onError={hideNocImg}
										/>
									) : ('')}

								</div>
								{props.noc}
							</div>
						</span>)
				}
				{props?.onlyShortName ? (
					<div className={'competitor-short-name d-inline-flex text-truncate' + (small && ' small') + strike}>{shortName} {seed} {extradata}</div>
				) : (
					<>
						<div className={`competitor-long-name d-none ${extradata !== undefined ? 'd-sm-inline-flex' : 'd-sm-block'} text-truncate ${small ? 'small' : ''} ${strike}`}> {name} {seed} {extradata}</div>
						<div className={`competitor-short-name d-inline-flex d-sm-none ${small ? 'small' : ''} ${breakCouples ? 'text-wrap' : 'text-truncate'} ${strike}`}> {shortName} {seed} {extradata}</div>
					</>
				)}
			</div>
		</>
		//</React.Fragment>
	)
}


export const Competitor = React.memo((props) => {
	let athlete;
	//teamAthletes: pinta una lista con todos los atletas del equipo.
	if (props.teamAthletes) {
		const noSubstitute = athlete = props.teamAthletes?.filter(row => {
			if (!row?.eventUnitEntries || row?.eventUnitEntries?.some(ath => ath.eue_code !== 'SUBSTITUTE')) {
				return row
			}
		})

		athlete = noSubstitute?.sort((a, b) => a.order - b.order).map((item, key) => {
			let p = Object.assign({}, props, item?.athlete);
			return (<CompetitorLink {...p} key={key} />)
		})
	} else {
		athlete = CompetitorLink(props)
	}

	return (<>{athlete}</>)
});



// NOT IN USE
export const Competitor2Lines = React.memo(({ familyName, givenName, noc, code, hidePicture, showCaptain, showSuspendedCode, showStarter, props, alwaysNoc }) => {

	let params = useUrlFriendlyToParameters();
	let captain = props?.eventUnitEntries?.find(eue => eue.eue_code === 'CAPTAIN') ? '(Captain)' : ''
	let starter = props?.eventUnitEntries?.find(eue => eue.eue_code === 'STARTER' && eue.eue_value === 'Y') ? '*' : ''
	let suspendedCode = props?.eventUnitEntries?.find(eue => eue.eue_code === 'STATUS')?.eue_value;
	suspendedCode = (<SportCode discipline='BKB' entity='@AthleteStatus' code={suspendedCode} />)
	let d_block_d_sm_none = alwaysNoc ? "" : "d-block d-sm-none";
	let competitor_country_flag_container = alwaysNoc ? 'competitor-country-flag-container-always-noc' : 'competitor-country-flag-container';
	let hideNoc = props?.hideNoc === undefined ? false : props?.hideNoc;



	params["mirs_code"] = code;
	const url = getURL(params, 'bios')
	return (

		//<React.Fragment key={code + "_competitor"}>

		<Link to={url} className='competitor-container'>
			{showStarter ? <div className='w-5'>{starter}</div> : ''}
			{
				!hidePicture &&
				<div className='competitor-image-container d-none d-sm-block' >
					<div className='competitor-image' >

						<picture>
							<img
								className='object-fit-cover-picture-img'
								src={`/assets/images/photos/photo.webp`}
								alt={familyName} />
						</picture>
					</div>
				</div>
			}

			<div className='competitor-name'>
				{!hideNoc && (
					<span className={`competitor-country  ${d_block_d_sm_none}`}>
						<div className='competitor-country-container'>
							<div className={competitor_country_flag_container}>
								<img className='competitor-country-flag' aria-hidden="true" src={`/assets/images/flags/${noc}.png`} alt={noc} />
							</div>
							{noc}
						</div>
					</span>
				)}
				<span className='competitor-first'> {givenName} </span>
				<span className='competitor-last'> {familyName} </span>

			</div>
			{showCaptain ? <div>{captain}</div> : ''}
			{showSuspendedCode ? <div>{suspendedCode}</div> : ''}

		</Link>
		//</React.Fragment>
	)
});




export default Competitor


